import {jsonMember, jsonObject} from "typedjson";

@jsonObject
export class PitUser {

  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: true })
  id: number;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false })
  oid: string;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: true })
  login: string;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: true })
  fio: string;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false })
  email: string;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false })
  phone: string;

  /**
   * должность
   */
  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false })
  post: string;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false })
  description: string;

  @jsonMember({constructor: Boolean, emitDefaultValue: false, isRequired: false})
  isLocked: boolean;
}
